export const CAMDEN_LIVE_GALAXY_ID = '65e95c2b95ff6915e2f5f361';
export const CAMDEN_LIVE_GALAXY_SLUG = 'camden-live-galaxy';

export const CAMDEN_LIVE_ROUTES = {
  galaxy: `/galaxies/${CAMDEN_LIVE_GALAXY_SLUG}`,
  region: '/localops/region/camden?src=galaxies_discovery',
  regionFromProfile: '/localops/region/camden?src=camden-live-galaxy',
  howItWorks: '/localops/how-it-works',
  map: '/playermap?regionSlug=camden&marketSlug=camden&source=camden_live_galaxy',
};

export function isCamdenLiveGalaxy({ galaxy, galaxyId } = {}) {
  const values = [
    galaxyId,
    galaxy?._id,
    galaxy?.id,
    galaxy?.slug,
    galaxy?.name,
  ]
    .filter(Boolean)
    .map((value) => String(value).trim().toLowerCase());

  return values.some(
    (value) =>
      value === CAMDEN_LIVE_GALAXY_ID ||
      value === CAMDEN_LIVE_GALAXY_SLUG ||
      value === 'camden live',
  );
}
